class NotificationService {
  constructor() {
    this.isSupported = 'Notification' in window;
    this.permission = this.isSupported ? Notification.permission : 'denied';
  }

  // Check if notifications are supported
  isNotificationSupported() {
    return this.isSupported;
  }

  // Get current permission status
  getPermission() {
    return this.permission;
  }

  // Request notification permission
  async requestPermission() {
    if (!this.isSupported) {
      console.log('Browser notifications are not supported');
      return 'denied';
    }

    if (this.permission === 'granted') {
      return 'granted';
    }

    try {
      const permission = await Notification.requestPermission();
      this.permission = permission;
      console.log('Notification permission:', permission);
      return permission;
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      return 'denied';
    }
  }

  // Show a notification
  showNotification(title, options = {}) {
    if (!this.isSupported) {
      console.log('Notifications not supported');
      return null;
    }

    if (this.permission !== 'granted') {
      console.log('Notification permission not granted');
      return null;
    }

    try {
      const notification = new Notification(title, {
        icon: '/logo192.png', // You can customize this
        badge: '/logo192.png',
        vibrate: [200, 100, 200],
        requireInteraction: false,
        ...options
      });

      // Auto-close notification after 5 seconds if not interacted with
      setTimeout(() => {
        notification.close();
      }, 5000);

      return notification;
    } catch (error) {
      console.error('Error showing notification:', error);
      return null;
    }
  }

  // Show a new message notification
  showMessageNotification(senderName, messageContent, conversationId, onClickCallback) {
    const notification = this.showNotification(`New message from ${senderName}`, {
      body: messageContent.length > 100 ? messageContent.substring(0, 100) + '...' : messageContent,
      tag: `message-${conversationId}`, // Prevents duplicate notifications for same conversation
      data: {
        conversationId: conversationId,
        type: 'new_message'
      }
    });

    if (notification && onClickCallback) {
      notification.onclick = (event) => {
        event.preventDefault();
        window.focus();
        onClickCallback(conversationId);
        notification.close();
      };
    }

    return notification;
  }

  // Check if the page is currently focused
  isPageFocused() {
    return document.visibilityState === 'visible' && document.hasFocus();
  }

  // Should show notification (only if page is not focused or conversation is not active)
  shouldShowNotification(conversationId, activeConversationId) {
    // Don't show if permission not granted
    if (this.permission !== 'granted') {
      return false;
    }

    // Show if page is not focused
    if (!this.isPageFocused()) {
      return true;
    }

    // Show if different conversation is active
    if (conversationId !== activeConversationId) {
      return true;
    }

    return false;
  }
}

const notificationService = new NotificationService();
export default notificationService;
